import React from "react";
import ExtensionCard from "./ExtensionCard/ExtensionCard";
import ExtensionDialog from "./ExtensionDialog/ExtensionDialog";
import "./Extensions.css";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

const Extensions = ({
  extensions,
  onStartNewChat,
  onUpdateExtension,
  onRemoveExtension,
  onSectionChange,
  setSelectedSection,
  setNav,
  featured,
}) => {


  const [selectedExtension, setSelectedExtension] = React.useState(null);
  const [isDialogVisible, setDialogVisible] = React.useState(false);

  const handleExtensionClick = (extension) => {
    setSelectedExtension(extension);
    setDialogVisible(true);
  };

  const handleDialogHide = () => {
    setSelectedExtension(null);
    setDialogVisible(false);
  };

  const handleEditExtension = () => {
    // console.log("Edit extension:", selectedExtension);
  };

  const handleStartChat = (extension) => {
    if (onStartNewChat && extension) {
      onStartNewChat(extension);
    }
    setDialogVisible(false);
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',                        // 1 card per row on mobile
          sm: 'repeat(2, 1fr)',            // 2 cards per row on small screens
          md: 'repeat(3, minmax(250px, 1fr))', // 3 cards per row on medium and up
          xl: 'repeat(4, minmax(250px, 1fr))', // 3 cards per row on medium and up
        },
        gap: 2,
        width: '100%',
        padding: 2,
      }}
      className="extension-main"
    >

      {extensions.map((extension) => (
        <ExtensionCard
          key={extension.id}
          extension={extension}
          onClick={() => handleExtensionClick(extension)}
          onStartChat={handleStartChat}
          onSectionChange={onSectionChange}
          setSelectedSection={setSelectedSection}
          setNav={setNav}
          onEdit={handleEditExtension}
          selectedExtension={selectedExtension}
          onUpdateExtension={onUpdateExtension}
          onRemoveExtension={onRemoveExtension}
          featured={featured}

        />
      ))}

    </Box>
  );
};

Extensions.propTypes = {
  extensions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onStartNewChat: PropTypes.func.isRequired,
  onUpdateExtension: PropTypes.func.isRequired,
  onRemoveExtension: PropTypes.func.isRequired,
};

export default Extensions;
